import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import Button, { Appearance } from 'Shared/Button';

import { FadeContainer, RelativeSpinner, RelativeReject, IconContainer, Status } from 'Shared/Fields/Toggle';

type PropType = StyledProps & {
  feedback: () => Promise<void>;
  flexInnerDiv?: boolean;
};

type StateType = {
  status: Status;
};

class FeedbackWrapper extends React.Component<PropType, StateType> {
  mounted: boolean = false;

  state = {
    status: Status.Default,
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onFeedback = () => {
    this.setState({ status: Status.Pending });
    this.props
      .feedback()
      .then(() => {
        if (this.mounted) {
          this.setState({ status: Status.Fulfilled });
        }
      })
      .catch(() => {
        if (this.mounted) {
          this.setState({ status: Status.Rejected });
        }
        setTimeout(() => {
          if (this.mounted) {
            this.setState({ status: Status.Default });
          }
        }, 800);
      })
      .then(() => {
        if (this.mounted) {
          this.setState({ status: Status.Default });
        }
      });
  };

  render() {
    const status = this.state.status;
    const { compose, feedback, flexInnerDiv, ...restProps } = this.props;
    return (
      <Button
        css={compose()}
        appearance={Appearance.Bare}
        onClick={this.onFeedback}
        {...restProps}
      >
        <IconContainer>
          <styled.Div css={{ ...(flexInnerDiv && {display: 'flex'}), ...(status !== Status.Default && { opacity: 0 }) }}>{this.props.children}</styled.Div>
          <FadeContainer visible={status !== Status.Default}>
            {/*adding text here will zoom in/out accurateley, but icons are not affected...*/}
            {status === Status.Pending && <RelativeSpinner />}
            {status === Status.Rejected && <RelativeReject />}
          </FadeContainer>
        </IconContainer>
      </Button>
    );
  }
}
export default styled(FeedbackWrapper);
